// extracted by mini-css-extract-plugin
export default {"carouselItem":"VarietyCarousel_carouselItem__i3SVB","carouselCaption":"VarietyCarousel_carouselCaption__hwyYB"};